import React from 'react';
import { EditableInfoComponent, Row } from 'components';
import { SpecialRateIcon } from 'components/common/icons/SpecialRateIcon';
import { RatesAddEditModal } from 'feature/clientTabs/shipping/specialRates/addEdit';
import { DeleteModal } from 'feature/clientTabs/shipping/specialRates/delete';
import { ShippingMethodType } from 'typings/client';
import { SpecialShippingRateCard } from './specialShippingRateCard';
import styles from './styles.module.scss';
import { useSpecialRates } from './useSpecialRates';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { PERMISSIONS } from 'constants/permissions';

export interface Price {
  metrics: 'KG' | 'VOLUME';
  measurementRange: string;
  price: string;
}

export interface SpecialRate {
  id?: string;
  clientId: string;
  warehouseId: string;
  countryId: string;
  warehouseName?: string;
  countryName?: string;
  city: string;
  shippingMethod: ShippingMethodType | '';
  prices: Price[];
  specialHandling: '';
}

export const SpecialRates = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const {
    openModal,
    dataToEdit,
    addDisabled,
    specialRatesData,
    isDeleteModalOpen,
    onHandleEdit,
    onHandleDelete,
    onDeleteModalClose,
    onModalStateChange,
  } = useSpecialRates();
  return (
    <>
      <Row className={styles.shipping_special_rate}>
        <EditableInfoComponent
          title={'Special Shipping Rates'}
          icon={<SpecialRateIcon />}
          creatable={hasAccess(PERMISSIONS.clients.special_shipping_rate.write)}
          editable={false}
          disabled={addDisabled}
          onAdd={onModalStateChange}
        />
        {specialRatesData.map((i: SpecialRate, index: number) => (
          <SpecialShippingRateCard
            key={index + i.warehouseId}
            specialRate={i}
            onHandleEdit={onHandleEdit}
            onHandleDelete={onHandleDelete}
          />
        ))}
      </Row>
      <RatesAddEditModal modalState={openModal} onModalStateChange={onModalStateChange} dataToEdit={dataToEdit} />
      <DeleteModal openModal={isDeleteModalOpen} onDeleteModalClose={onDeleteModalClose} dataToDelete={dataToEdit} />
    </>
  );
});
